import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DashboardStatus } from '@shared-features/models/dashboard-status.model';

type Status = {
  amount: number,
  count:number,
  status:string
  icon:string,
  theme:string
  inverted?:boolean
}
@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DashboardCardComponent {
  @Input() statues: DashboardStatus[];
}
